import _extends from "@babel/runtime/helpers/esm/extends";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Components as AccordianComponents } from './accordian.style';
import Icon from '../Icon';
function Accordian(_ref) {
  let {
    className = 'accordian',
    children,
    expanded = false,
    headerContent,
    item = {},
    index = 0,
    size = 'medium',
    fit = 'medium',
    variant = 'vanity',
    onCardToggle
  } = _ref;
  const OnAccoridanClick = (item, index) => {
    if (typeof onCardToggle === 'function') {
      onCardToggle(item, index);
    }
  };
  const headerType = typeof headerContent === 'string' ? 'button' : 'div';
  return _jsxs(AccordianComponents.Wrapper, _extends({
    variant: variant,
    className: className
  }, {
    children: [_jsxs(AccordianComponents.Header, _extends({
      className: "".concat(className, "-header"),
      type: "button",
      as: headerType,
      size: size === 'medium' ? fit : size,
      variant: variant,
      onClick: () => OnAccoridanClick(item, index)
    }, {
      children: [_jsx(AccordianComponents.HeaderLeftBlock, {
        children: _jsx(AccordianComponents.HeaderContent, {
          children: headerContent
        })
      }), _jsx(AccordianComponents.HeaderRightBlock, {
        children: _jsx(Icon, {
          name: expanded ? 'chevron-up' : 'chevron-down'
        })
      })]
    })), expanded && _jsx(AccordianComponents.Body, _extends({
      className: "".concat(className, "-body"),
      "aria-expanded": expanded,
      size: size === 'medium' ? fit : size,
      variant: variant
    }, {
      children: children
    }))]
  }));
}
export default Accordian;